import { useState, useRef, useCallback } from 'react'
import { toPng } from 'html-to-image'
import { useTranslation } from '../../i18n/LanguageContext'
import './ShareModal.css'

const ScrollIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20">
    <defs>
      <linearGradient id="sScrollGr" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#fde68a" />
        <stop offset="50%" stopColor="#fbbf24" />
        <stop offset="100%" stopColor="#f59e0b" />
      </linearGradient>
      <filter id="sScrollGlow">
        <feGaussianBlur stdDeviation="0.8" />
        <feComponentTransfer>
          <feFuncA type="linear" slope="1.2" />
        </feComponentTransfer>
      </filter>
    </defs>
    <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"
      fill="url(#sScrollGr)" stroke="#92400e" strokeWidth="1" filter="url(#sScrollGlow)" />
    <path d="M14 2v6h6" fill="none" stroke="#92400e" strokeWidth="1" />
    <line x1="8" y1="11" x2="16" y2="11" stroke="#78350f" strokeWidth="1.5" strokeLinecap="round" opacity="0.8" />
    <line x1="8" y1="14.5" x2="15" y2="14.5" stroke="#78350f" strokeWidth="1.5" strokeLinecap="round" opacity="0.6" />
    <line x1="8" y1="18" x2="13" y2="18" stroke="#78350f" strokeWidth="1.5" strokeLinecap="round" opacity="0.4" />
  </svg>
)

const BotIconSm = () => (
  <svg viewBox="0 0 1024 1024" width="72" height="72">
    <defs>
      <linearGradient id="botLogo" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#fde68a" />
        <stop offset="50%" stopColor="#fbbf24" />
        <stop offset="100%" stopColor="#f59e0b" />
      </linearGradient>
    </defs>
    <g transform="translate(0,1024) scale(0.1,-0.1)" fill="url(#botLogo)">
      <path d="M7751 8440 c-84 -38 -451 -330 -830 -660 -73 -63 -135 -115 -139 -115 -4 0 -104 33 -222 72 -575 192 -1341 397 -1935 518 -341 70 -459 58 -611 -63 -275 -218 -1102 -1032 -1589 -1565 -176 -193 -192 -208 -218 -203 -144 29 -647 109 -738 118 -151 15 -190 6 -220 -54 -39 -76 -11 -131 89 -182 94 -47 364 -161 572 -240 225 -86 220 -84 224 -98 2 -7 20 -101 40 -208 85 -453 274 -1163 503 -1895 l79 -251 -199 -229 c-221 -255 -396 -470 -481 -588 -86 -122 -95 -179 -36 -238 40 -41 101 -40 181 2 106 57 437 314 736 572 l173 148 167 -59 c475 -169 1386 -419 1923 -526 150 -30 273 -56 274 -58 2 -2 20 -52 41 -113 47 -137 138 -369 213 -544 39 -92 69 -147 94 -174 36 -38 40 -39 85 -34 58 6 102 49 104 100 6 130 -28 444 -66 602 -13 55 -44 165 -68 245 -25 80 -68 222 -95 315 -28 94 -54 177 -57 186 -5 12 8 25 47 48 l53 31 20 -24 c11 -13 38 -44 59 -70 l39 -47 -37 -83 c-21 -46 -36 -94 -34 -107 2 -19 33 -39 167 -106 89 -46 174 -83 187 -83 28 0 43 21 80 113 l28 67 95 -6 c110 -7 111 -8 142 -102 24 -72 48 -102 82 -102 39 0 321 109 340 131 22 28 22 31 -13 123 -17 44 -29 82 -28 86 2 4 33 34 69 68 l67 62 64 -29 c109 -51 118 -53 142 -37 33 21 180 327 173 357 -5 18 -30 36 -94 69 l-87 45 4 50 c2 28 4 70 4 94 l1 44 77 22 c158 48 157 39 43 310 -25 60 -54 118 -63 128 -21 24 -63 19 -149 -15 l-61 -25 -67 67 -67 68 41 91 c56 121 49 139 -64 176 -27 9 -86 34 -130 55 -115 54 -121 55 -147 27 -13 -13 -40 -56 -61 -96 -38 -71 -39 -72 -70 -65 -18 4 -57 10 -87 13 l-55 6 -36 90 c-47 119 -50 120 -206 71 -148 -48 -220 -81 -228 -107 -4 -11 7 -58 26 -111 l33 -91 -70 -63 c-38 -35 -76 -63 -85 -64 -9 0 -46 14 -82 30 -76 34 -117 38 -140 13 -8 -10 -45 -76 -80 -146 -36 -71 -67 -125 -70 -120 -3 5 -40 153 -82 329 -42 175 -85 355 -95 399 -39 163 -72 323 -85 418 -23 167 3 260 110 390 83 101 458 499 724 770 l235 238 70 -70 70 -70 -46 -98 c-25 -54 -50 -110 -56 -125 l-12 -28 -130 0 c-126 0 -132 -1 -155 -25 l-25 -24 0 -250 0 -251 29 -32 29 -33 133 -2 132 -1 27 -74 c15 -40 39 -96 53 -125 15 -29 27 -55 27 -59 0 -3 -43 -50 -95 -104 -74 -76 -95 -104 -95 -126 0 -22 30 -58 161 -190 88 -89 171 -167 184 -174 39 -21 70 -4 170 91 l95 91 47 -27 c27 -15 84 -42 128 -60 l80 -33 5 -124 c5 -126 15 -159 50 -178 11 -6 115 -10 260 -10 l242 0 29 29 29 29 0 130 0 130 54 17 c29 9 84 34 122 54 l69 38 97 -93 c134 -130 130 -130 296 25 184 172 242 235 242 264 0 19 -27 52 -102 125 l-102 100 42 91 c23 49 45 104 48 121 4 17 10 33 15 35 4 3 66 7 136 8 137 2 162 10 182 54 7 15 11 116 11 267 0 312 14 289 -180 296 l-141 5 -23 66 c-13 37 -37 93 -55 125 l-31 57 95 90 c52 49 98 99 101 112 3 13 0 34 -8 48 -7 13 -90 99 -185 191 -216 209 -203 207 -354 59 l-76 -75 -84 40 c-46 22 -103 45 -126 51 l-41 11 -4 134 c-3 126 -4 136 -27 160 l-24 26 -253 0 -252 0 -26 -31 c-25 -29 -26 -35 -26 -159 l0 -128 -37 -12 c-21 -7 -76 -30 -121 -52 l-84 -41 -70 70 -70 70 88 73 c121 100 370 353 658 670 420 462 436 481 436 547 0 61 -67 123 -132 123 -13 0 -43 -9 -67 -20z m-3263 -451 c293 -32 935 -177 1482 -335 356 -102 415 -127 472 -194 66 -76 69 -149 11 -244 -35 -57 -725 -742 -963 -957 -504 -454 -624 -520 -880 -483 -387 56 -1447 341 -1763 474 -152 63 -199 139 -148 238 56 110 888 947 1231 1239 209 178 291 233 380 257 69 18 62 18 178 5z m3102 -948 c0 -113 1 -121 25 -149 18 -21 38 -32 68 -37 64 -11 194 -61 260 -100 89 -53 102 -50 208 52 l90 87 89 -89 c50 -49 90 -94 90 -100 0 -6 -38 -48 -85 -95 -102 -101 -103 -109 -41 -218 41 -71 65 -126 111 -255 24 -67 48 -77 185 -77 l110 0 0 -135 0 -135 -117 0 c-75 0 -127 -5 -143 -13 -20 -10 -34 -39 -71 -142 -25 -72 -63 -160 -83 -196 -54 -98 -52 -108 55 -215 l91 -91 -98 -91 -98 -91 -81 78 c-44 43 -89 83 -101 89 -24 13 -59 6 -94 -18 -48 -34 -185 -98 -235 -110 -124 -30 -128 -36 -135 -195 l-5 -120 -132 -3 -133 -3 0 106 c0 118 -15 169 -52 184 -13 5 -61 21 -108 35 -47 15 -125 50 -175 79 -53 30 -100 50 -115 49 -16 -1 -54 -31 -110 -87 -47 -47 -90 -84 -95 -84 -6 1 -48 42 -94 90 l-85 89 86 87 c47 49 88 98 92 109 4 15 -9 52 -46 125 -30 57 -68 149 -86 204 -42 131 -48 135 -206 135 l-116 0 0 135 0 135 113 0 c152 0 163 7 206 131 18 52 58 142 88 200 66 127 68 117 -50 237 l-82 82 92 92 92 92 88 -86 c98 -95 120 -106 161 -85 142 76 194 98 267 118 126 33 135 46 135 200 l0 119 135 0 135 0 0 -119z m-4650 -1196 c435 -100 983 -248 1370 -370 140 -44 311 -115 373 -155 102 -64 176 -173 237 -345 74 -212 282 -964 406 -1473 79 -325 77 -400 -13 -450 -62 -34 -146 -31 -345 13 -565 126 -1407 378 -1635 490 -135 66 -219 142 -274 250 -102 195 -392 1193 -500 1717 -44 218 -35 317 35 353 45 23 159 14 346 -30z m3396 -1299 c17 -43 37 -82 45 -86 8 -4 50 -10 94 -14 44 -3 108 -13 143 -21 45 -11 69 -12 82 -5 15 8 37 46 95 167 2 3 155 -63 161 -70 3 -3 -11 -40 -30 -82 -36 -77 -43 -110 -28 -130 4 -6 26 -25 49 -43 23 -18 65 -62 93 -97 60 -76 72 -78 178 -40 38 14 72 25 74 25 12 0 80 -181 72 -189 -5 -5 -40 -19 -79 -31 -98 -31 -99 -34 -96 -135 1 -47 -3 -110 -9 -141 -18 -85 -11 -97 78 -141 42 -20 79 -38 81 -40 5 -3 -67 -163 -79 -176 -4 -5 -41 8 -83 27 -41 20 -83 36 -93 36 -10 0 -54 -35 -98 -77 -45 -43 -98 -92 -119 -110 -44 -38 -46 -54 -12 -153 14 -40 24 -74 22 -75 -15 -7 -147 -45 -158 -45 -10 0 -23 25 -38 71 -31 97 -49 113 -115 105 -46 -6 -126 1 -228 20 -32 5 -40 3 -61 -20 -14 -15 -35 -53 -47 -86 -12 -33 -24 -60 -25 -60 -2 0 -41 18 -88 41 l-85 41 39 83 c21 46 39 90 39 98 0 8 -24 36 -52 62 -29 26 -77 75 -107 108 -30 34 -62 65 -73 69 -13 5 -42 -4 -90 -28 -38 -19 -72 -33 -75 -30 -6 6 -52 166 -53 183 0 6 24 19 53 29 105 34 107 36 107 112 1 37 7 103 15 147 8 44 15 90 15 103 0 28 -39 52 -131 81 l-69 22 45 89 45 89 81 -34 c44 -19 90 -35 102 -35 12 0 52 30 97 73 42 39 93 85 113 100 53 40 56 65 17 158 -18 44 -31 81 -29 83 9 7 165 54 174 52 5 -2 24 -38 41 -80z m-688 -617 c68 -22 72 -26 67 -49 -3 -14 -8 -56 -11 -93 -7 -66 -8 -68 -42 -83 -19 -8 -37 -12 -39 -10 -3 3 -17 51 -32 108 -44 163 -44 161 -29 156 7 -3 46 -16 86 -29z"/>
      <path d="M7352 6549 c-133 -23 -242 -81 -341 -180 -76 -76 -122 -147 -159 -251 -23 -64 -27 -88 -27 -198 0 -102 4 -138 22 -195 63 -199 228 -363 428 -425 104 -33 252 -31 360 4 206 66 365 223 428 421 18 57 22 93 21 190 0 104 -4 130 -28 200 -60 173 -167 295 -331 378 -104 52 -261 76 -373 56z m293 -208 c185 -84 303 -318 262 -517 -21 -96 -51 -156 -113 -223 -97 -104 -203 -151 -347 -151 -177 0 -323 93 -404 257 -33 67 -38 86 -41 168 -7 162 31 269 132 371 138 138 335 174 511 95z"/>
      <path d="M6403 4206 c-203 -50 -343 -231 -343 -446 0 -177 103 -335 267 -413 64 -30 75 -32 178 -32 103 0 114 2 177 32 91 43 133 77 185 146 100 137 111 332 27 487 -60 111 -186 203 -312 229 -66 14 -112 13 -179 -3z m232 -156 c200 -97 246 -360 91 -516 -128 -128 -321 -124 -443 9 -50 54 -66 85 -83 154 -34 147 61 324 199 368 66 21 175 14 236 -15z"/>
    </g>
  </svg>
)

const formatDate = (d) => {
  if (!d) return t('share.na')
  return new Date(d).toLocaleDateString('en-US', {
    month: 'short', day: 'numeric', year: 'numeric'
  })
}

const ShareModal = ({ entry, onClose }) => {
  const { t } = useTranslation()
  const [status, setStatus] = useState(null)
  const cardRef = useRef(null)

  const buildWhatsAppText = () => {
    const changes = (entry.changes || []).map(c => `• ${c}`).join('\n')
    return [
      t('share.whatsAppTitle', { version: entry.version }),
      `📅 ${formatDate(entry.date)}`,
      '',
      t('share.whatsAppChanges'),
      changes,
      '',
      t('share.whatsAppDownload')
    ].join('\n')
  }

  const generateImageBlob = useCallback(async () => {
    if (!cardRef.current) return null
    const dataUrl = await toPng(cardRef.current, {
      quality: 1,
      pixelRatio: 2,
      backgroundColor: '#0d0705'
    })
    const res = await fetch(dataUrl)
    return res.blob()
  }, [])

  const handleShareWhatsApp = async () => {
    try {
      setStatus('generating')
      const blob = await generateImageBlob()
      if (!blob) throw new Error('Failed to generate image')

      const file = new File([blob], `unitybot-update-v${entry.version}.png`, { type: 'image/png' })

      if (navigator.canShare && navigator.canShare({ files: [file] })) {
        await navigator.share({
          title: `UNITY-BOT Update v${entry.version}`,
          text: buildWhatsAppText(),
          files: [file]
        })
        setStatus('whatsapp')
      } else {
        const url = `https://api.whatsapp.com/send/?text=${encodeURIComponent(buildWhatsAppText())}`
        window.open(url, '_blank')
        setStatus('whatsapp')
      }
    } catch {
      const url = `https://api.whatsapp.com/send/?text=${encodeURIComponent(buildWhatsAppText())}`
      window.open(url, '_blank')
      setStatus('whatsapp')
    }
    setTimeout(() => setStatus(null), 2500)
  }

  const handleCopyText = async () => {
    try {
      const text = buildWhatsAppText()
      await navigator.clipboard.writeText(text)
      setStatus('copied')
      setTimeout(() => setStatus(null), 2500)
    } catch {
      setStatus('error')
      setTimeout(() => setStatus(null), 2500)
    }
  }

  const handleDownloadImage = useCallback(async () => {
    if (!cardRef.current) return
    try {
      setStatus('generating')
      const dataUrl = await toPng(cardRef.current, {
        quality: 1,
        pixelRatio: 2,
        backgroundColor: '#0d0705'
      })
      const link = document.createElement('a')
      link.download = `unitybot-update-v${entry.version}.png`
      link.href = dataUrl
      link.click()
      setStatus('downloaded')
      setTimeout(() => setStatus(null), 2500)
    } catch {
      setStatus('error')
      setTimeout(() => setStatus(null), 2500)
    }
  }, [entry])

  const statusText = {
    whatsapp: t('share.statusWhatsApp'),
    copied: t('share.statusCopied'),
    generating: t('share.statusGenerating'),
    downloaded: t('share.statusDownloaded'),
    error: t('share.statusError')
  }

  return (
    <div className="share-modal__overlay" onClick={onClose}>
      <div className="share-modal__container" onClick={e => e.stopPropagation()}>
        <button className="share-modal__close" onClick={onClose}>
          <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>

        <h4 className="share-modal__title">
          <ScrollIcon />
          <span>{t('share.shareUpdate')}</span>
        </h4>

        <div className="share-modal__card" ref={cardRef}>
          <div className="share-modal__card-badge">
            {entry.version === 'latest' || false ? t('share.badgeLatest') : t('share.badgeUpdate')}
          </div>

          <div className="share-modal__card-header">
            <BotIconSm />
            <span className="share-modal__card-brand">{t('share.cardBrand')}</span>
          </div>

          <div className="share-modal__card-version-row">
            <span className="share-modal__card-version">
              v{entry.version}
              {entry.mandatory && <span className="share-modal__card-mandatory">{t('share.mandatory')}</span>}
            </span>
            <span className="share-modal__card-date">{formatDate(entry.date)}</span>
          </div>

          <div className="share-modal__card-divider">
            <span>{t('share.whatsNew')}</span>
          </div>

          <ul className="share-modal__card-changes">
            {(entry.changes || []).map((c, i) => (
              <li key={i}>{c}</li>
            ))}
          </ul>

          <div className="share-modal__card-footer">
            <div className="share-modal__card-footer-line" />
            <span className="share-modal__card-footer-text">unity-bot.com</span>
            <div className="share-modal__card-footer-line" />
          </div>
        </div>

        {status && (
          <div className={`share-modal__toast share-modal__toast--${status}`}>
            {statusText[status]}
          </div>
        )}

        <div className="share-modal__actions">
          <button
            className="share-modal__btn share-modal__btn--whatsapp"
            onClick={handleShareWhatsApp}
          >
            <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
            </svg>
            <span>{t('share.whatsApp')}</span>
          </button>

          <button
            className="share-modal__btn share-modal__btn--image"
            onClick={handleDownloadImage}
            disabled={status === 'generating'}
          >
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="3" y="3" width="18" height="18" rx="2" ry="2" />
              <circle cx="8.5" cy="8.5" r="1.5" />
              <polyline points="21 15 16 10 5 21" />
            </svg>
            <span>{t('share.image')}</span>
          </button>

          <button
            className="share-modal__btn share-modal__btn--copy"
            onClick={handleCopyText}
          >
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
              <path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1" />
            </svg>
            <span>{t('share.copy')}</span>
          </button>
        </div>
      </div>
    </div>
  )
}

export default ShareModal
